import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-active-shipment',
  imports: [CommonModule, MatIconModule],
  templateUrl: './active-shipment.component.html',
  styleUrl: './active-shipment.component.scss'
})
export class ActiveShipmentComponent {
  @Input({ required: true }) data!: any[];
  datas!: any[];

  ngOnInit() {
    this.datas = this.data;
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Shipping':
        return 'shipping';
      case 'Delivered':
        return 'delivered';
      case 'Canceled':
        return 'canceled';
      default:
        return '';
    }
  }

  getStatusIcon(status: string): string {
    switch (status) {
      case 'Shipping':
        return 'local_shipping';
      case 'Delivered':
        return 'check_circle';
      case 'Canceled':
        return 'cancel';
      default:
        return 'info';
    }
  }

  getInitials(name: string): string {
    if (!name) return '';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }
}
